<template>
  <div class="invoiced-goods-services">
    <div class="search-warehouse">
      <el-checkbox v-model="hideClosed" @change="onHideClosedChange">隐藏已关闭</el-checkbox>
      <div class="add">
        <el-button class="btn-blue" @click="add">+新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="invoicedGoodsServicesList" style="width: 100%" :row-class-name="tableRowClassName">
        <el-table-column v-for="(item, index) in tableTitleList" :key="index" :label="item.label" :prop="item.prop"
          :min-width="item.width" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button :disabled="!scope.row.status" class="btn-text mod-btn" type="text"
              @click="mod(scope.row)">编辑</el-button>
            <el-button v-if="!scope.row.status" class="btn-text" type="text" @click="open(scope.row)">开启</el-button>
            <el-button v-else class="btn-text" type="text" @click="close(scope.row)">关闭</el-button>
            <el-button class="btn-text" type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增/编辑 -->
    <el-dialog :title="ivoicedGoodsServicesForm.id ? '编辑' : '新增'" top="18vh" :visible.sync="ivoicedGoodsServicesDialog"
      width="420px">
      <div class="border"></div>
      <el-form ref="ivoicedGoodsServicesForm" :model="ivoicedGoodsServicesForm" :rules="lookUpRules">
        <el-form-item label="开票商品或劳务名称" prop="name">
          <el-input v-model="ivoicedGoodsServicesForm.name" class="white" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeLookUpDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveLookUp('ivoicedGoodsServicesForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import InvoicedGoodsServices from "models/invoiced-goods-services";
import InvoiceGoods from "common/mixins/invoice-goods";
import { modifyNetTitle } from "common/js/util";
export default {
  mixins: [InvoiceGoods],
  data() {
    return {
      hideClosed: true,
      tableTitleList: [
        { label: '序号', prop: 'sort', width: '' },
        { label: '开票商品或劳务名称', prop: 'name', width: '' }
      ],
      ivoicedGoodsServicesDialog: false,
      ivoicedGoodsServicesForm: {
        id: '',
        name: ''
      },
    };
  },
  created() {
    modifyNetTitle('开票商品或劳务名称')
    this.fetchList();
  },
  methods: {
    fetchList() {
      const params = this.hideClosed ? { hideClosed: true } : {};
      this.initInvoicedGoodsServicesList(params);
    },
    onHideClosedChange() {
      this.fetchList();
    },
    tableRowClassName({ row }) {
      if (!row.status) {
        return "close-row";
      }
    },
    //新增
    add() {
      this.ivoicedGoodsServicesDialog = true;
    },
    closeLookUpDialog() {
      this.ivoicedGoodsServicesForm.name = ''
      this.ivoicedGoodsServicesForm.id = ''
      this.ivoicedGoodsServicesDialog = false;
    },
    saveLookUp(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ivoicedGoodsServicesForm.id) {
            let data = {};
            data.id = this.ivoicedGoodsServicesForm.id;
            data.name = this.ivoicedGoodsServicesForm.name;
            InvoicedGoodsServices.postUpdateIvoicedGoodsServices(this.ivoicedGoodsServicesForm.id, data).then(res => {
              if (res.success) {
                this.fetchList();
                this.$message.success("修改成功");
                this.closeLookUpDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.ivoicedGoodsServicesForm.name;
            InvoicedGoodsServices.postAddIvoicedGoodsServices(data).then(res => {
              if (res.success) {
                this.fetchList();
                this.$message.success("新增成功");
                this.closeLookUpDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    mod(row) {
      this.ivoicedGoodsServicesForm.name = row.name
      this.ivoicedGoodsServicesForm.id = row.id
      this.add()
    },
    open(row) {
      this.$confirm("是否开启该开票商品或劳务名称？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => { });
    },
    close(row) {
      this.$confirm("是否关闭该开票商品或劳务名称？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => { });
    },
    commonFun(row) {
      InvoicedGoodsServices.postUpdatIvoicedGoodsServicesStatus(row.id).then(res => {
        if (res.success) {
          this.fetchList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    del(row) {
      this.$confirm("是否删除该开票商品或劳务名称？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          InvoicedGoodsServices.postDeleteIvoicedGoodsServices(row.id).then(res => {
            if (res.success) {
              this.$message.success("删除成功");
              this.fetchList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    }
  }
};
</script>
<style lang="scss">
.invoiced-goods-services {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;

  .search-warehouse {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;

    .el-checkbox {
      margin-right: 16px;
      .el-checkbox__label {
        padding-left: 4px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        font-family: 'PingFang SC-Regular';
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #2E68EA;
        border-color: #2E68EA;
      }
      .el-checkbox__inner:hover {
        border-color: #2E68EA;
      }
      .el-checkbox__input.is-disabled .el-checkbox__inner::after {
        border-color: #fff;
      }
      .el-checkbox__input.is-disabled .el-checkbox__inner {
        background-color: #EBEEF5;
        border-color: #EBEEF5;
      }
    }
    .el-checkbox.is-checked .el-checkbox__label {
      color: #2E68EA;
    }
  }

  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #999999;
    font-family: 'PingFang SC-Regular';

    .el-button.mod-btn {
      color: #999999;
      font-size: 14px;
    }
  }

  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }

    .el-dialog__body {
      padding: 0px;

      .el-form {
        padding: 20px;

        .el-form-item {
          .el-form-item__label {
            width: 100%;
            height: 28px;
            line-height: 24px;
            text-align: left;
          }

          .el-form-item__content {
            width: 100%;
          }
        }
      }

      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
    }

    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
